import {SpriteLoadData, SpriteSettings} from "./SpriteLoader";
import {SoundEventId} from "./AudioLoader";

export enum AnimationWrapMode {

    Clamp,
    Repeat
}

export interface AnimationSoundEvent
{
    frame:number
    soundId:SoundEventId
}

export interface Animation {

    sprites: string[],
    wrapMode: AnimationWrapMode,
    frameRate: number
    sounds: AnimationSoundEvent[]
}

export function createAnimations(animationData: Partial< {

    id: string,
    sprites: SpriteLoadData[],
    wrapMode: AnimationWrapMode,
    frameRate: number
    sounds: AnimationSoundEvent[]
}>[]): { [key: string]: Animation } {

    return Object.fromEntries(animationData.map(anim => {

        return [anim.id, {
            sprites: anim.sprites.map(s => typeof s === "string" ? s : s.id),
            wrapMode: anim.wrapMode || AnimationWrapMode.Clamp,
            frameRate: anim.frameRate,
            sounds: anim.sounds
        }]
    }))
}

export function createSpriteList(p: Partial<{
    src: string;
    start: number;
    end: number;
    digits: number,
    settings: Partial<SpriteSettings>
}>) {

    const sprites = []
    const increment = Math.sign(p.end - p.start)
    for (let i = p.start; i != p.end+increment; i += increment) {
        const counter = `${i}`.padStart(p.digits, "0")
        const name = p.src.replace("%", counter)
        sprites.push({id: name, settings: p.settings})
    }
    return sprites;
}
